import type { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdIntlMw } from './pages'

type TIdToPageMapIntlMw = Record<PageIdIntlMw, TPageMapValue>

export const ID_TO_PAGE_MAP_INTL_MW: TIdToPageMapIntlMw = {
  [PageIdIntlMw.ANALYZING]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/AnalyzingPage').then((m) => ({
        default: m.AnalyzingPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/AnalyzingPage'),
  },
  [PageIdIntlMw.START]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/StartPage').then((m) => ({
        default: m.StartPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/StartPage'),
  },
  [PageIdIntlMw.LIVING_UP_POTENTIAL]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/LivingUpPotentialPage').then((m) => ({
        default: m.LivingUpPotentialPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/LivingUpPotentialPage'),
  },
  [PageIdIntlMw.STRUGGLE_MOST]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/StruggleMostPage').then((m) => ({
        default: m.StruggleMostPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/StruggleMostPage'),
  },
  [PageIdIntlMw.STUCK_AREAS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/StuckAreasPage').then((m) => ({
        default: m.StuckAreasPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/StuckAreasPage'),
  },
  [PageIdIntlMw.REASON_TO_START]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/ReasonToStartPage').then((m) => ({
        default: m.ReasonToStartPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/ReasonToStartPage'),
  },
  [PageIdIntlMw.GOOD_COMPANY]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/GoodCompanyPage').then((m) => ({
        default: m.GoodCompanyPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/GoodCompanyPage'),
  },
  [PageIdIntlMw.LITTLE_INTEREST]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/LittleInterestPage').then((m) => ({
        default: m.LittleInterestPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/LittleInterestPage'),
  },
  [PageIdIntlMw.EMOTION_SHIFTS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/EmotionShiftsPage').then((m) => ({
        default: m.EmotionShiftsPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/EmotionShiftsPage'),
  },
  [PageIdIntlMw.CALM_DOWN]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/CalmDownPage').then((m) => ({
        default: m.CalmDownPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/CalmDownPage'),
  },
  [PageIdIntlMw.RECHARGING]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/RechargingPage').then((m) => ({
        default: m.RechargingPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/RechargingPage'),
  },
  [PageIdIntlMw.ACCEPT_COMPLIMENTS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/AcceptComplimentsPage').then((m) => ({
        default: m.AcceptComplimentsPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/AcceptComplimentsPage'),
  },
  [PageIdIntlMw.PRIORITIZE_OTHERS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/PrioritizeOthersPage').then((m) => ({
        default: m.PrioritizeOthersPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/PrioritizeOthersPage'),
  },
  [PageIdIntlMw.LEAN_ON_SOMEONE]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/LeanOnSomeonePage').then((m) => ({
        default: m.LeanOnSomeonePage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/LeanOnSomeonePage'),
  },
  [PageIdIntlMw.UNDERSTOOD_BY_OTHERS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/UnderstoodByOthersPage').then((m) => ({
        default: m.UnderstoodByOthersPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/UnderstoodByOthersPage'),
  },
  [PageIdIntlMw.WE_FEEL_YOU]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/WeFeelYouPage').then((m) => ({
        default: m.WeFeelYouPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/WeFeelYouPage'),
  },
  [PageIdIntlMw.OVERTHINKING_DECISIONS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/OverthinkingDecisionsPage').then(
        (m) => ({
          default: m.OverthinkingDecisionsPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_mw/pages/urge/OverthinkingDecisionsPage'),
  },
  [PageIdIntlMw.AUTOPILOT]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/AutopilotPage').then((m) => ({
        default: m.AutopilotPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/AutopilotPage'),
  },
  [PageIdIntlMw.UNABLE_TO_START]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/UnableToStartPage').then((m) => ({
        default: m.UnableToStartPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/UnableToStartPage'),
  },
  [PageIdIntlMw.DISTRACTIONS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/DistractionsPage').then((m) => ({
        default: m.DistractionsPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/DistractionsPage'),
  },
  [PageIdIntlMw.MEANING_TO_DO]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/MeaningToDoPage').then((m) => ({
        default: m.MeaningToDoPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/MeaningToDoPage'),
  },
  [PageIdIntlMw.OTHER_SIDE]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/OtherSidePage').then((m) => ({
        default: m.OtherSidePage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/OtherSidePage'),
  },
  [PageIdIntlMw.GENUINE_STRENGTHS]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/GenuineStrengthsPage').then((m) => ({
        default: m.GenuineStrengthsPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/GenuineStrengthsPage'),
  },
  [PageIdIntlMw.TIME_INVESTMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/TimeInvestmentPage').then((m) => ({
        default: m.TimeInvestmentPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/TimeInvestmentPage'),
  },
  [PageIdIntlMw.HEAR_ABOUT_US]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/HearAboutUsPage').then((m) => ({
        default: m.HearAboutUsPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/HearAboutUsPage'),
  },
  [PageIdIntlMw.PREPARE_FLOW]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/prepareFlow/PrepareFlow').then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdIntlMw.PATTERNS_IMPACT]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/urge/PatternsImpactPage').then((m) => ({
        default: m.PatternsImpactPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/urge/PatternsImpactPage'),
  },
  [PageIdIntlMw.EMAIL]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/email/EmailPage'),
  },
  [PageIdIntlMw.OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/offer/OfferPage').then((m) => ({
        default: m.OfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/offer/OfferPage'),
  },
  [PageIdIntlMw.SPECIAL_DISCOUNT]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/specialDiscount/SpecialDiscountPage').then(
        (m) => ({
          default: m.SpecialDiscountPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_mw/pages/specialDiscount/SpecialDiscountPage'),
  },
  [PageIdIntlMw.CANCEL_OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/cancelOffer/CancelOfferPage').then((m) => ({
        default: m.CancelOfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/cancelOffer/CancelOfferPage'),
  },
  [PageIdIntlMw.PAYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/payment/PaymentPage').then((m) => ({
        default: m.PaymentPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/payment/PaymentPage'),
  },
  [PageIdIntlMw.REGISTRATION]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/account/AccountNove8'),
  },
  [PageIdIntlMw.NAME_ENTRY]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/name/NamePage').then((m) => ({
        default: m.NamePage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/name/NamePage'),
  },
  [PageIdIntlMw.REPORT]: {
    Component: lazy(() =>
      import('cohorts/intl_mw/pages/report/ReportPage').then((m) => ({
        default: m.ReportPage,
      })),
    ),
    preload: () => import('cohorts/intl_mw/pages/report/ReportPage'),
  },
}
